import { render } from "./ProjectComponent.vue?vue&type=template&id=313e87db&scoped=true"
import script from "./ProjectComponent.vue?vue&type=script&lang=js"
export * from "./ProjectComponent.vue?vue&type=script&lang=js"

import "./ProjectComponent.vue?vue&type=style&index=0&id=313e87db&scoped=true&lang=css"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313e87db"]])

export default __exports__